import React, { forwardRef, useId } from "react";
import * as RadixRadio from "@radix-ui/react-radio-group";
import "./Radio.css";

export const RadioGroup = forwardRef(function RadioGroup(
  { className = "", orientation = "vertical", children, ...props },
  ref
) {
  return (
    <RadixRadio.Root
      ref={ref}
      className={`ui-radio-group ui-radio-group-${orientation} ${className}`}
      orientation={orientation}
      {...props}
    >
      {children}
    </RadixRadio.Root>
  );
});

export const RadioItem = forwardRef(function RadioItem(
  { label, hint, id: idProp, className = "", value, ...props },
  ref
) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <label htmlFor={id} className={`ui-radio-row ${className}`}>
      <RadixRadio.Item ref={ref} id={id} value={value} className="ui-radio" {...props}>
        <RadixRadio.Indicator className="ui-radio-indicator" />
      </RadixRadio.Item>
      {(label || hint) && (
        <span className="ui-radio-text">
          {label && <span className="ui-radio-label">{label}</span>}
          {hint && <span className="ui-radio-hint">{hint}</span>}
        </span>
      )}
    </label>
  );
});
